// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1yEoP","addWidgetButton":"Header_addWidgetButton__2qIgI","dashboardTabs":"Header_dashboardTabs__1X0RM","active":"Header_active__2pDxS"};